import { makeStyles } from '@mui/styles';
const sectionAccordionStyles = makeStyles(({ palette }) => ({
    root: {
        minHeight: 'unset',
        backgroundColor: palette.common.white,
        '&': {
            '&.Mui-expanded': {
                margin: 0,
            },
            '&:before': {
                opacity: 0,
            },
        },
        border: 'initial',
    },
    accordionSummaryContent: {
        margin: 0,
        '&': {
            '&.Mui-expanded': {
                minHeight: 'fit-content',
            },
        },
    },
    header: {
        padding: 0,
        marginTop: 12,
        backgroundColor: palette.common.white,
        marginRight: 0,
        minHeight: 'unset',
    },
    expandSection: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        margin: 0,
    },
    accordionDetails: {
        padding: 0,
        marginLeft: 10,
        border: 'initial',
    },
    expandIconContainer: {
        position: 'absolute',
        right: 0,
    },
    expandIcon: {
        color: palette.common.black,
        display: 'flex',
    },
    empty: {
        pointerEvents: 'none',
    },
}), { name: 'Common_SectionAccordion' });
export default sectionAccordionStyles;
//# sourceMappingURL=sectionAccordion.styles.js.map